module.exports = __webpack_public_path__ + "static/media/searchreplace.513d9382.svg";